import React, { useState } from "react";
import { StyledExpandableList, StyledExpandableListItem, StyledExpandableListToggle } from "./DataTable.styles";

/**
 * A table-cell bulleted list that collapses to `maxVisible` items with a "+N more" toggle once
 * there are more than that many - expanding grows the row (no cell content is ever clipped), and
 * a second toggle collapses it back.
 */
function ExpandableBulletList({ items = [], maxVisible = 2, emptyText = "-" }) {
    const [expanded, setExpanded] = useState(false);

    if (!items.length) {
        return emptyText;
    }

    const visibleItems = expanded ? items : items.slice(0, maxVisible);
    const hiddenCount = items.length - visibleItems.length;

    return (
        <StyledExpandableList>
            {visibleItems.map((item, index) => (
                <StyledExpandableListItem key={index}>{item}</StyledExpandableListItem>
            ))}
            {hiddenCount > 0 && (
                <StyledExpandableListToggle type="button" onClick={() => setExpanded(true)}>
                    {`+${hiddenCount} more`}
                </StyledExpandableListToggle>
            )}
            {expanded && items.length > maxVisible && (
                <StyledExpandableListToggle type="button" onClick={() => setExpanded(false)}>
                    Show less
                </StyledExpandableListToggle>
            )}
        </StyledExpandableList>
    );
}

ExpandableBulletList.displayName = "ExpandableBulletList";

export default ExpandableBulletList;
